import React from "react"
import cookies from "../../images/cookies.svg"
import { Link } from "react-router-dom"

export default function CookieNotice({ setOpenCookies }) {
  return (
    <>
      <section className="cookie-consent">
        <div className="overlay bg-blue">
          <div className="max-width p-5">
            <h1 className="text-white flex items-center">
              Cookies <img src={cookies} alt="" className="ml-5" />
            </h1>
            <p className="text-white mb-10">
              We use cookies to ensure our website works properly and to help us
              improve our services, we collect data to understand how people use
              the site. By allowing all cookies, we can enhance your experience
              by, for example helping you find information more quickly and
              tailoring content or marketing your preferences. Select “Allow all
              cookies” to agree or “Manage preferences” to manage cookie
              settings. You can find out more by viewing our Cookie Policy.
            </p>

            <ul className="flex items-center justify-center">
              <li className="mr-5">
                <Link
                  to="/cookie-preferences"
                  className="btn-white block"
                  onClick={() => setOpenCookies(true)}
                >
                  Manage Preferences
                </Link>
              </li>
              <li>
                <button
                  className="btn-white"
                  onClick={() => setOpenCookies(true)}
                >
                  Accept All Cookies
                </button>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  )
}
